import { render, staticRenderFns } from "./termsOfService.vue?vue&type=template&id=4c1d7f60&scoped=true"
import script from "./termsOfService.vue?vue&type=script&lang=js"
export * from "./termsOfService.vue?vue&type=script&lang=js"
import style0 from "./termsOfService.vue?vue&type=style&index=0&id=4c1d7f60&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1d7f60",
  null
  
)

export default component.exports